import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import Slider from 'react-slick';
import styles from './Reviews.scss';// to import local scss fle

class Reviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
  }
  render() {
    const settings = {
      dots: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
    };
    return (
      <div className={cn('row', styles.reviewsContainer)}>
        <h1>TESTIMONIALS</h1>
        <Slider {...settings}>
          <div >
            <span className={styles.review}>
              We appreciate and discover large amounts
              of talented under-recruited players on
              your website and Twitter timeline.
            </span><br /><br />
            <span className={styles.reviewBy}>&#34;Anonymous D1 Football Coach&#34;</span>
          </div>
          <div >
            <span className={styles.review}>
              I am very pleased! Thanks, to everyone at
              MyRecruitBoard for helping me get recruited.
              It&#39;s an amazing service and I had a number of
              college coaches contact me. Very easy to use.
              I appreciate you all!
            </span><br /><br />
            <span className={styles.reviewBy}>&#34;J. Hernandez, Texas&#34;</span>
          </div>
          <div >
            <span className={styles.review}>
              Thank you for your great
              service without your website
              I wouldn&#39;t have gotten recruited.
            </span><br /><br />
            <span className={styles.reviewBy}>&#34;Brandon V. New Jersey&#34;</span>
          </div>
        </Slider>
      </div>
    );
  }
}

export default Reviews;




// WEBPACK FOOTER //
// ./src/components/Reviews/Reviews.js